import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

export interface ClockInScheduleWarningDialogData {
  scheduled_entry_time: string;
  current_time: string;
}

export type ClockInScheduleWarningDialogResult = 'clock-in' | 'manage-exception' | false;

@Component({
  selector: 'app-clock-in-schedule-warning-dialog',
  templateUrl: './clock-in-schedule-warning-dialog.component.html',
  styleUrl: './clock-in-schedule-warning-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatIcon],
})
export class ClockInScheduleWarningDialogComponent {
  readonly dialog_ref = inject(MatDialogRef<ClockInScheduleWarningDialogComponent, ClockInScheduleWarningDialogResult>);
  readonly data = inject<ClockInScheduleWarningDialogData>(MAT_DIALOG_DATA);

  confirmClockIn(): void {
    this.dialog_ref.close('clock-in');
  }

  manageException(): void {
    this.dialog_ref.close('manage-exception');
  }
}
